import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const NavItemsContainer = (props) => {
  const {
    children,
    tag,
    isExpanded = false,
    id,
    accessibility,
    className,
  } = props;
  const TagName = tag;

  const classNames = cn(
    className,
    'list-none p-0 m-0',
    {
      block: isExpanded,
    },
    {
      hidden: !isExpanded,
    },
  );

  return (
    <TagName id={id} className={classNames} {...accessibility}>
      {children}
    </TagName>
  );
};

NavItemsContainer.propTypes = {
  tag: PropTypes.string,
  isExpanded: PropTypes.bool,
  id: PropTypes.string.isRequired,
  accessibility: PropTypes.object,
};

NavItemsContainer.defaultProps = {
  tag: 'ul',
  isExpanded: false,
  accessibility: {},
};

export default NavItemsContainer;
